import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const vendorEmployeeList = createAsyncThunk('vendorEmployeeList', async ({ pageable: data, navigate, shop_id }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `employee`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'shop_id': shop_id
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const vendorEmployeeListSlice = createSlice({
    name: 'vendorEmployeeList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(vendorEmployeeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(vendorEmployeeList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default vendorEmployeeListSlice.reducer;
